import { Params } from '@/helpers/convertEventsFromApi';

export const ERROR_MESSAGE: string =
  'Сбой в работе оборудования, повторите попытку позже.';

export interface IPurchases {}

export enum OrderStatusEnum {
  DELAYED = 'pause',
  EXECUTING = 'studying',
  CONFIRMED = 'approved',
  CANCELLED = 'cancelled',
  NEW = 'initial',
  COMPLETED = 'completed',
}

export interface ApiModel {
  children: Kids;
  events: Events;
  orders: Orders;
}

export interface ApiData {
  data: ApiModel;
}

export interface Order {
  date: Date | string | number;
  id: Id;
  event_id: Id;
  kid_id: Id;
  sinse?: Date | string | number;
  status: OrderStatusEnum;
  deduct: string;
  academic_year?: string;
  pfdod_contracts?: Array<Contract>;
  certificate_on_hold?: null | undefined | string;
  certificate_amount_type?: null | undefined | string;
}

export interface Kid {
  id: Id;
  last_name: string;
  first_name: string;
  middle_name: string;
}

export interface Contract {
  serial: string | number;
  download_url: string;
}

export interface Event extends Params {
  id: Id;
}

export type Id = string | number;
export type Events = Array<Event>;
export type Kids = Array<Kid>;
export type Orders = Array<Order>;



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/types.ts